import React from 'react'

export const NewTabLink: React.FC<React.ComponentProps<'a'>> = props => (
  <a {...props} target="_blank" rel="noopener noreferrer" />
)
